import { createApiCall } from 'lib/base';

const EDIT_HOME_WIDGET_MENU_ITEM = 'EDIT_HOME_WIDGET_MENU_ITEM';

const editHomeWidgetMenuItemApi = createApiCall<{ id: string; payload: any }>(
  EDIT_HOME_WIDGET_MENU_ITEM,
  ({ id, payload }) => ({
    endpoint: `api/admin/home-widget-menu-items/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editHomeWidgetMenuItemApi;
